import { render, staticRenderFns } from "./InsurancePolicies.vue?vue&type=template&id=68dad8d2&scoped=true"
import script from "./InsurancePolicies.vue?vue&type=script&lang=js"
export * from "./InsurancePolicies.vue?vue&type=script&lang=js"
import style0 from "./InsurancePolicies.vue?vue&type=style&index=0&id=68dad8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dad8d2",
  null
  
)

export default component.exports